import React from 'react';
import { styled } from 'baseui';
import { Button, SIZE } from 'baseui/button';
import { DIVIDER, SIZE as TABLESIZE, Table } from 'baseui/table-semantic';
import type { UserGroup, UserMinified } from '../../types/userGroup';
import GroupManagementModal from './group-management-modal';
import { TableInnerContainer, TableOuterContainer } from './TableContainer';
const ButtonContainer = styled('div', ({
  $theme
}) => ({
  marginBottom: $theme.sizing.scale600,
  marginTop: $theme.sizing.scale600
}));
type GroupManagementProps = {
  groups: UserGroup[];
  users: UserMinified[];
};
const GroupManagement = (props: GroupManagementProps) => {
  const [showCreateGroupModal, setShowCreateGroupModal] = React.useState(false);
  const [updateGroupId, setUpdateGroupId] = React.useState<number | null>(null);
  const {
    groups,
    users
  } = props;
  const handleCloseModal = () => {
    setShowCreateGroupModal(false);
    setUpdateGroupId(null);
  };
  return <TableOuterContainer>
      {showCreateGroupModal && <GroupManagementModal showUpdateModal={showCreateGroupModal} group={groups.find(group => group.id === updateGroupId) ?? null} handleCloseModal={handleCloseModal} users={users} />}
      <ButtonContainer>
        <Button size={SIZE.compact} onClick={() => setShowCreateGroupModal(true)}>
          Create Group
        </Button>
      </ButtonContainer>
      <TableInnerContainer>
        <Table size={TABLESIZE.spacious} divider={DIVIDER.grid} columns={['Id', 'Group Name', 'Members', 'Actions']} overrides={{
        Root: {
          style: {
            maxHeight: '80%'
          }
        }
      }} data={groups.map(group => [group.id, group.name, group.members.map(id => users.find(u => u.id === id)?.email).join(', '), <Button key={group.id} size={SIZE.compact} onClick={() => {
        setUpdateGroupId(group.id);
        setShowCreateGroupModal(true);
      }}>
              Edit
            </Button>])} />
      </TableInnerContainer>
    </TableOuterContainer>;
};
export default GroupManagement;